import type { ResponsiveDialogContentProps } from '@/shared/components/ui/custom/responsive-dialog';
import { ResponsiveDialogContent } from '@/shared/components/ui/custom/responsive-dialog';
import { cn } from '@/shared/utils/cn';

export function DownloadModalContent(props: ResponsiveDialogContentProps) {
  const { className, ...rest } = props;
  return (
    <ResponsiveDialogContent
      className={cn('flex flex-col gap-2', className)}
      {...rest}
    />
  );
}
